/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Stat_UpdatedInputs */

const vi_fleet_stat_updated = /** @type {(inputs: Fleet_Stat_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật`)
};

/**

* @param {Fleet_Stat_UpdatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_stat_updated = /** @type {((inputs?: Fleet_Stat_UpdatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Stat_UpdatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_stat_updated(inputs)
});